import { ChevronRight, Home } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

export function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  if (pathnames.length === 0) return null;

  return (
    <nav className="flex items-center text-sm text-slate-500 mb-4" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        <li>
          <Link
            to="/dashboard"
            className="hover:text-slate-900 transition-colors flex items-center"
          >
            <Home className="h-4 w-4" />
          </Link>
        </li>
        {pathnames.map((value, index) => {
          const last = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;
          
          // Format the name: capitalize, replace hyphens with spaces
          const name = value.charAt(0).toUpperCase() + value.slice(1).replace(/-/g, " ");

          return (
            <li key={to} className="flex items-center space-x-2">
              <ChevronRight className="h-4 w-4 flex-shrink-0 text-slate-400" />
              {last ? (
                <span className="font-medium text-slate-900 truncate max-w-[150px]">
                  {name}
                </span>
              ) : (
                <Link
                  to={to}
                  className="hover:text-slate-900 transition-colors"
                >
                  {name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
